import React from 'react';
import { connect } from 'react-redux';
import fields, { globalFieldLengths } from '@/constants/fields';
import DictionaryInput from '../../dictionaries/components/DictionaryInput';
import LookupValue from './LookupValue';
import LookupValueContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/LookupValueContainer';
import { validationWarningDictionaryLookupOptions } from '../helper';

const LookupName = ({
  name,
  options,
  lookupItemUUID,
  dictionaryUUID,
  isEditing,
  exists,
  canRead,
  updateProperties,
  updatePropertiesLookup,
  saveErrors,
  activeLookupName,
}) => {
  const setWarnings = (warnings) => updatePropertiesLookup({ validationWarnings: warnings });

  const updateActiveLookupProperties = (value) => (
    updateProperties(lookupItemUUID, { isDirty: true, name: value })
  );

  const validationWarningCheck = () => {
    const warnings = [];
    validationWarningDictionaryLookupOptions(dictionaryUUID, options, activeLookupName, warnings);
    setWarnings(warnings);
  };

  if (!isEditing) {
    return (<LookupValue value={name} className="td-editable-name" />);
  }

  const error = saveErrors.find((e) => (
    e.context.lookupItemUUID === lookupItemUUID && e.fields.includes(fields.NAME)));

  return (
    <LookupValueContainer exists={exists} canRead={canRead}>
      <DictionaryInput
        error={error !== undefined}
        fluid
        type="lookup.item.name"
        text={name}
        onChange={updateActiveLookupProperties}
        onBlur={validationWarningCheck}
        maxLength={globalFieldLengths.name}
      />
    </LookupValueContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(LookupName);
